<template>
  <div class="product-image">
    <!-- <ProductDiscount :discount="item.bottlePricing" /> -->
    <template v-if="lowStock && !outOfStock">
      <div class="low-stock-badge">
        Low Stock
      </div>
    </template>

    <router-link
      :to="path"
      class="product-link"
      tag="a"
    >
      <AImage
        :img="item.image"
        preset="wineproductteaser"
        contain
      />
    </router-link>
  </div>
</template>

<script>
// Mixins
import carouselProductMixin from '../../mixins/carouselProductMixin'
import purchaseMixin from '@aspedia/vuejs-ecommerce-ui/mixins/item-purchase-qty.js'
import generalutils from '@aspedia/vuejs-ecommerce-ui/mixins/general-utils.js'

export default {
  name: 'carousel-product-image',
  mixins: [carouselProductMixin, purchaseMixin, generalutils]
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.product-image {
  padding: 1.5em;

  .image-container {
    height: 0;
    padding-bottom: var(--product-image-aspect-ratio, 100%);
    position: relative;
    z-index: 1;
    overflow: hidden;
  }

  .image {
    background:var(--product-image-background);
    position: absolute;
    height:100%;
    width:100%;
    // padding: 1.5em;
  }

  img {
      object-fit: var(--product-image-fit);
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
  }

  .image {
    img {
      transform: scale(1);
      transition:transform .5s ease-in-out;
      transform-origin: center;
    }
  }

  @include hover-focus {
    img {
      transform: scale(var(--product-image-hover-scale));
    }
  }
}

.product-link {
  cursor: pointer;
}
</style>
